import React from 'react'
import { print } from 'graphql'
import { grapheneGet } from 'utils'
import { initializeApollo } from '@gql/client'
import { PaginaDocument, ProgettiDocument, SoluzioniDocument } from '@gql/graphql'
import { ListingProgettiDocument } from '@gql/graphql-get'
import { NextWrapper } from 'data-fetching-wrapper'
import { Page } from '@components/organisms'
import { Button } from '@components/atoms'
import { ProgettiHubTemplate } from '@components/templates'
import { fromParsedUrlToParams } from '@utils/listing'

const ProgettiHub = ({ pagina, listing }) => (
  <ProgettiHubTemplate pagina={pagina} listing={listing} />
)

export const getServerSideProps = NextWrapper.getServerSideProps(
  async ({ query, locale, preview, previewData, req, res }) => {
    const client = initializeApollo(locale)

    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: { chiave: 'progetti', preview },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    // recuperare i dati dal query string
    const listingDefaultParams = {
      params: {
        ...fromParsedUrlToParams(query, true),
        ordinamento: {
          value: '-ordinamento_web'
        }
      }
    }
    listingDefaultParams
    //console.log(JSON.stringify(listingDefaultParams, null, 2))

    const encodedVariables = encodeURIComponent(JSON.stringify(listingDefaultParams))
    const encodedQuery = encodeURIComponent(print(ListingProgettiDocument))

    const response = await grapheneGet.get(
      `?lang=${locale}&query=${encodedQuery}&operationName=ListingProgetti&variables=${encodedVariables}`
    )
    const { data } = response.data

    const listingProgetti = data?.listingProgetti

    if (!listingProgetti) {
      return {
        notFound: true,
      }
    }

    res.setHeader('Cache-Control', 'public, s-maxage=60, stale-while-revalidate')
    return {
      props: { pagina, listing: listingProgetti },
    }
  }
)

export default ProgettiHub
